export function createRoutes() {
  return [
    {
      path: 'profile',
      component: () => import(/* webpackChunkName: "ProfileChrome" */'./ProfileChrome.vue'),
      children: [
        {
          path: 'edit',
          name: 'profileEdit',
          component: () => import(/* webpackChunkName: "EditProfile" */'./EditProfile.vue'),
        },
      ],
    },
  ];
}
